import { CapoPlugin } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];